import React from 'react'
import Form from './Form'
import { useFMIBulkForm } from './Form/useFMIBulkForm'
import SelectInstructors from './SelectInstructors'
import Spacer from '@berlitz/spacer'
import HR from '@components/HR/HR'
import { LoaderWrapper, Paddings } from './style'
import ViewCalendars from './ViewCalendars'
import { IBulkForm } from './interface'
import Skeleton from 'react-loading-skeleton'

export const BulkFormLoader: React.FC = () => {
  return (
    <LoaderWrapper>
      <div className="label">
        <div className="step">
          <Skeleton circle width="38px" height="38px" />
        </div>
        <Skeleton width="200px" height="33px" />
      </div>

      <div className="form md">
        <div className="fields">
          <Skeleton width="250px" height="33px" />
          <Skeleton width="230px" height="33px" />
          <Skeleton circle width="38px" height="38px" />
        </div>

        <div className="button">
          <Skeleton width="150px" height="33px" />
        </div>
      </div>

      <div className="form xs">
        <Skeleton width="250px" height="33px" />
      </div>

      <Spacer size="sm" />

      <HR />
    </LoaderWrapper>
  )
}

const BulkForm: React.FC<IBulkForm> = () => {
  const { Program } = useFMIBulkForm()

  if (!Program) {
    return null
  }

  return (
    <>
      <Form />

      <Spacer size="xxs" />

      <HR />

      <SelectInstructors />

      <ViewCalendars />

      <Paddings>
        <Spacer size="xxxl" />
      </Paddings>
    </>
  )
}

export default BulkForm
